<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onSelectedVendor'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.거래처명}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='grid-wrap'>
        <dx-data-grid ref='refInventoryGrid'
          :data-source='inventoryReceiptInfo'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          :focused-row-key.sync='focusedRowKey'
          key-expr="seqId"
          @toolbar-preparing='onToolbarPreparing'
          @cell-prepared='onCellPreparedOutput'
          @row-removed='onRowRemoved' @row-removing="onRowRemoving"
          @row-inserted='onRowInserted' @row-inserting='onRowInserting'
          @row-updated='onRowUpdated' @row-updating='onRowUpdating'
          @editor-preparing='onEditorPreparing'
          @rowPrepared="onRowPrepared"
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="exportTitle"
          />
          <DxEditing
            :allow-deleting="false"
            :allow-updating="(userInfo.permission & crudAllow) > 0"
            :allow-adding="false"
            :use-icons="true"
            mode='raw'
          >
          </DxEditing>
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumnFixing :enabled="true"/>
          <DxStateStoring
            :enabled="false"
            type="localStorage"
            storage-key="storage"
          />
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="출고일"
            data-field="발생일자"
            dataType='date'
            format='yyyy-MM-dd'>
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="협력사"
            data-field="입고업체">
            <DxLookup
              :data-source="companyInfoLookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :caption="$store.getters.getGroupName"
            data-field="차종"
            :visible='true'
            width="60"
          >
            <DxLookup
              :data-source="carTypeLookup"
              display-expr="모델코드"
              value-expr="모델코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="품번"
            data-field="품번"
            width="110"
          >
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품명"
            data-field="품명"
            :visible='true'
            width="190"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="재질"
            data-field="재질"
            :visible='true'
            width="130"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="false"
            caption="두께"
            data-field="자사두께"
            :visible='true'
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="가로"
            data-field="자사가로"
            :visible='true'
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="세로"
            data-field="자사세로"
            :visible='true'
            width="60"
          >
          </DxColumn>
           <DxColumn
            :allowEditing='true'
            caption="중량"
            data-field="수량"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="코일수"
            data-field="코일수"
            :visible='true'
            format='#,##0'
            dataType="number"
            width="60"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="LOT_NO"
            data-field="lotNo"
            :visible='true'
            width="150"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구매단가"
            data-field="가격"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="운반비"
            data-field="운반비"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="구매금액"
            data-field="구매금액"
            :calculate-cell-value="calcAmount"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
           <DxColumn
            :allowEditing='isScarpInput'
            caption="스크랩처리"
            data-field="스크랩처리"
            :visible='true'
            width="80"
          >
            <DxLookup
              :data-source="scrapLookup"
              display-expr="코드명"
              value-expr="코드명"
            />
            <dx-required-rule v-if="isScarpInput" message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="false"
            caption="마감월"
            data-field="마감일자"
            dataType='date'
            format='yyyy-MM'
            width="80"
            :editor-options="{calendarOptions: {maxZoomLevel: 'year', minZoomLevel: 'century'}}"
          >
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :visible="true"
            caption="NO"
            data-field="seqId"
            width="50"
            sort-order="desc"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="입출구분"
            data-field="입출고구분"
            :visible='false'
          >
            <DxLookup
              :data-source="receiptTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
           <DxColumn
            :allowEditing="false"
            :visible="false"
            caption="재질품번"
            data-field="재질품번"
            width="50"
          >
          </DxColumn>
          <DxColumn
            width="90"
            :buttons="editSubButtons"
            type="buttons"
          />
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="발생일자"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format='#,##0'
              summary-type="sum"
              column="구매금액"
              display-format="{0}"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport, DxEditing, DxStateStoring } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import axios from 'axios'

export default {
  name: 'production-receipt',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      crudAllow: ConstDef.CRUD_ALLOW_구매,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '제품출하현황'
        }
      ],
      editSubButtons: ['edit', 'delete'],
      inventoryReceiptInfo: null,
      selectedRow: null,
      thisYear: null,
      yearArray: [],
      thisMonth: null,
      monthArray: [],
      exportTitle: null,
      receiptTypeLookup: null,
      focusedRowKey: null,
      selectedVendor: null,
      processingTypeLookup: null,
      meterialTypeLookup: null,
      selectedCoilCode: null,
      companyInfoLookup: null,
      scrapLookup: null,
      isScarpInput: false,
      carTypeLookup: null,
      maxSeqId: null,
      scrapPrice: null,
      showCompleted: false,
      qtyEditable: true,
      scrapPriceAll: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxLookup,
    DxEditing,
    DxRequiredRule,
    DxStateStoring
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ 'year': i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ 'name': i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ 'name': i + '월', value: '' + i })
      }
    }
    this.scrapLookup = ConstDef.SCRAP_LOOKUP
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.receiptTypeLookup = ConstDef.PURCHASE_INOUT_CODE
    // this.companyInfoLookup = this.$_.sortBy(this.$store.getters.getPartnersInfo, '거래처명')
    // this.companyInfoLookup.push({ 거래처명: '시중구매', 거래처코드: '시중구매' })
    // this.refreshCoilInfo()
    this.refreshScrapPriceAll()
    this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    calcAmount (row) {
      return row.수량 * (row.가격 + row.운반비)
    },
    isEditable (row) {
      if (this.showCompleted) {
        return false
      }
      this.qtyEditable = AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`)
      return this.qtyEditable
    },
    onCellPreparedOutput (e) {
      if (e.rowType === 'data' && e.column.dataField === '입출고구분') {
        if (e.data.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품반품' }).코드) { // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        }
      }
      if (e.rowType === 'data' && e.column.type !== undefined && e.column.type === 'buttons') {
        if (e.data.사용유무) {
          this.$Q(e.cellElement).find('.dx-icon-showpanel').hide()
        }
      }
      if (e.rowType === 'data' && e.column.type === 'buttons') {
        if (AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`) && !this.showCompleted) {
          this.$Q('.dx-link-delete').show()
          this.$Q('.dx-link-edit').show()
        } else {
          this.$Q('.dx-link-delete').hide()
        }
      }
    },
    onEditorPreparing (e) {
    },
    onRowPrepared (e) {
    },
    onRowInserted (row) {
    },

    onRowInserting (row) {

    },
    onRowRemoved (row) {
    },
    onRowRemoving (row) {
    },
    onRowUpdated (row) {
      this.isLoading = true
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()
      const param = [
        {
          seqId: row.data.seqId,
          발생일자: row.data.발생일자,
          마감일자: row.data.마감일자,
          수량: row.data.수량,
          코일수: row.data.코일수,
          운반비: row.data.운반비,
          lotNo: row.data.lotNo,
          updatetime: row.data.updatetime,
          updateid: row.data.updateid
        }
      ]
      this.$_sp.runUpdateSqlProc('창고수불', ['seqId'], null, param)
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
      let firstDay = `${AppLib.getToday().substring(0, 7)}-01 00:00:00`
      firstDay = AppLib.getTimestampFromString(firstDay)
      if (row.newData.발생일자 !== undefined) {
        if (row.newData.발생일자 < firstDay) {
          this.$snotify.info('발생일자는 전월로 변경할 수 없습니다.')
          row.cancel = true
        }
      }
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisYear = args.value
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: (args) => {
              this.$store.commit('deleteInoutList')
              this.thisMonth = args.value
              this.refreshVendorList(`${this.thisYear}-${this.thisMonth}`)
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          widget: 'dxCheckBox',
          options: {
            value: this.showCompleted,
            text: '선택월 마감자료',
            onValueChanged: (args) => {
              this.showCompleted = args.value
              this.refreshInventoryList()
            }
          }
        }
      )
    },
    refreshInventoryList () {
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-사급출고`
      this.isLoading = true
      let endDate = `${this.thisYear}-${this.thisMonth}-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
      endDate = AppLib.calcDateFromFormat(endDate, 1)
      let param = {
        startDate: `${this.thisYear}-${this.thisMonth}-01`,
        endDate: `${endDate}`,
        품목유형: ConstDef.구매품,
        자재유형: ConstDef.자재유형_원자재,
        거래처코드: this.selectedVendor,
        마감: 0
      }
      if (this.showCompleted) {
        param.마감 = 1
      }
      const scrap = this.$_sp.runNoEncodeFindProc('spFindAllScrapPriceByDate', { date: `${this.thisYear}-${this.thisMonth}-01` })
      const proc = this.$_sp.runNoEncodeFindProc('spFindAllInventoryReceiptByDateAndGoodsType', param)
      axios.all([scrap, proc])
        .then(axios.spread((...reponse) => {
          this.isLoading = false
          this.scrapPrice = this.$_sp.MakeModel(reponse[0])[0].가격
          this.inventoryReceiptInfo = this.$_sp.MakeModel(reponse[1]).filter(item => item.입출고구분 === ConstDef.사급출고)
          console.log(this.inventoryReceiptInfo)
          const where = this.$_.where(this.inventoryReceiptInfo, { 품번: 'SCRAP' })
          where.forEach(item => {
            let where = this.$_.find(this.scrapPriceAll, function (price) {
              return price.적용일자 <= item.발생일자 && price.만료일자 > item.발생일자
            })
            item.가격 = where.가격
          })
          const max = this.$_.max(this.inventoryReceiptInfo, function (item) { return item.seqId })
          this.maxSeqId = this.focusedRowKey = max.seqId
          // this.searchEmptyPressSize()
          this.makeCarModelLookup()
          this.companyInfoLookup = AppLib.getGroupByLookupCompany(this.$_, this.inventoryReceiptInfo, '입고업체', this.$store.getters.getPartnersInfo)
          console.log(this.companyInfoLookup)
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshScrapPriceAll () {
      this.$_sp.runNoEncodeFindSqlProc('스크랩코일가격', { 재질: 'SCRAP' })
        .then(data => {
          this.scrapPriceAll = this.$_sp.MakeModel(data)
          console.log(this.scrapPriceAll)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    searchEmptyPressSize () {
      const where = this.$_.where(this.inventoryReceiptInfo, { 자사두께: null })
      console.log(where)
      where.forEach(item => {
        this.$_sp.runNoEncodeFindProc('spFindAllPressSizeByCoilCode', { 품번: item.품번 })
          .then(data => {
            const result = this.$_sp.MakeModel(data)
            if (result.length > 0) {
              item.자사두께 = result[0].자사두께
              item.자사가로 = result[0].자사가로
              item.자사세로 = result[0].자사세로
            }
          })
      })
    },
    makeCarModelLookup () {
      const model = this.$_.uniq(this.inventoryReceiptInfo, item => item.차종)
      this.carTypeLookup = []
      model.forEach(item => {
        if (item.차종 !== null) {
          this.carTypeLookup.push(
            {
              모델코드: item.차종
            }
          )
        }
      })
      this.carTypeLookup = this.$_.sortBy(this.carTypeLookup, '모델코드')
    },
    onSelectedVendor () {
      this.selectedVendor = this.tabs[this.selectedIndex].입고업체
      this.refreshInventoryList()
    },
    refreshVendorList (date) {
      const param = {
        toDate: `${date}-${AppLib.getMonthLastDay(date.split('-')[0], date.split('-')[1])} 23:59:59`,
        fromDate: `${date}-01`,
        자재유형: ConstDef.자재유형_원자재,
        입출고구분: ConstDef.사급출고
      }
      this.$_sp.runNoEncodeFindProc('spFindAllCoilOutputVendorList', param)
        .then((data) => {
          this.tabs = this.$_sp.MakeModel(data)
          this.tabs.unshift({ 거래처명: 'ALL', 입고업체: 'ALL' })
          if (this.selectedVendor == null || (this.selectedVendor !== null && this.$_.findIndex(this.tabs, { 입고업체: this.selectedVendor }) < 0)) {
            this.selectedVendor = 'ALL'
            this.selectedIndex = 0
          } else {
            this.selectedIndex = this.$_.findIndex(this.tabs, { 입고업체: this.selectedVendor })
          }
          this.refreshInventoryList()
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // set emit
    setCoilCode (code) {
      // console.log(code)
      this.selectedCoilCode = code
    }
  }
}
</script>

<style lang="scss">

</style>
